import { render, staticRenderFns } from "./BookingAdmin.vue?vue&type=template&id=cda4bcf8&"
import script from "./BookingAdmin.vue?vue&type=script&lang=ts&"
export * from "./BookingAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports